import React, { FC, useContext, useEffect, useMemo, useState } from "react";

import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";

import ButtonPrimary from "shared/Button/ButtonPrimary";

import Editor from "./Editor";
import { useNavigate, useParams } from "react-router-dom";
import Input from "shared/Input/Input";
import { requestAPI } from "utils/api";

import CommunityBadge from "components_custom/CommunityBadge/CommunityBadge";
import { ArrowSmallLeftIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { GlobalDataContext } from "contexts/GlobalData";
import { UIContext } from "contexts/UIContext";



const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);

export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

function classNames(...classes: any) {
	return classes.filter(Boolean).join(' ')
}



const usePageLeaveWarning = ({message}: any) => {

	let id = "";
	const [isWarningActive, setIsWarningActive] = useState <any> (false);
	//const [id, setId] = useState <any> ("");

	const test = (_bool: boolean, _id: string) => {
		setIsWarningActive(_bool);
		id = _id;
	};
	
	useEffect(() => {
	  const handleBeforeUnload = (event: any) => {
		
		if (isWarningActive) {
		  event.preventDefault();
		  //event.returnValue = message;
		  
		  return message;
		}
	  };
  
	  const handlePopState = (event: any) => {
		
		

	
	  };
  
	  window.addEventListener('beforeunload', handleBeforeUnload);
	  window.addEventListener('popstate', handlePopState);
  
	  return () => {

		// (async () => {
		// 	//console.log("...",  contentsId)
		// 	console.log('r1 ....................', id)
		// 	const res_cp: any = await requestAPI ('FILE-CP', `community-temp-remove`, {
		// 		contentsId: id,
		// 	});
		// })();
		window.removeEventListener('beforeunload', handleBeforeUnload);
		window.removeEventListener('popstate', handlePopState);
	  };
	}, [isWarningActive, message]);
	
	
  
	return (test);
};



const CommunityPost = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}: any) => {

	const { id } = useParams();

	const { 
		initData,
	} = useContext (GlobalDataContext);
	
	const {
		toast,
		modal,
	} = useContext(UIContext);  

	let _rndId =  Number(new Date()).toString(); 

	_rndId = _rndId.slice(-5, _rndId.length);

	const [ contentsId, setContentsId ] = useState("");
	const [ title, setTitle ] = useState("");
	const [ data, setData ] = useState <any> ("");
	const [ editorHtmlString, setEditorHtmlString ] = useState("<p><br></p>");
	const [ originHtmlString, setOriginHtmlString ] = useState("");
	const [ rndId, setRndId ] = useState(_rndId);

	// const [query, setQuery] = useState('');
	// const [open, setOpen] = useState(true);
	const [selectType, setSelectType] = useState("review");
	const [reserveList, setReserveList] = useState([]);
	const [reserveSw, setReserveSw] = useState(true);
	const [reserveSelect, setReserveSelect] = useState(0);
	const [productList, setProductList] = useState([]);
	const [productSw, setProductSw] = useState(false);
	const [productSelect, setProductSelect] = useState(0);
	
	const [reviewType, setReviewType] = useState<'personal' | 'reserved'>('personal');
	const [reviewType2, setReviewType2] = useState<'personal2' | 'product'>('personal2');


	const [uploadedInfo, setUploadedInfo] = useState <any> ({});
	const [postImg, setPostImg] = useState([]);
	const [previewImg, setPreviewImg] = useState("");
	const [imgData, setImgData] = useState<any> (null);
	const [imgUrl, setImgUrl] = useState<any> (null);

	const [files, setFiles] = useState <any> ([]);
	const postFormat: any = {
		party: `<p>입력양식)</p><p>가고 싶은 투어 상품 : 일본 아소 투어</p><p>가고 싶은 일자: 협의 혹은 원하는 날짜 라이딩(운전) 경력: 라이딩 10년 , 운전 20년</p><p>보유 기종(차종): 혼다 골드윙</p><p>주행 성향: 안전운전 및 평균 시속 100KM</p><p>기타 요청: 나이 불문, 성별 불문, 기종불문 성격 잘 맞고, 유쾌하게 투어 하실분이면 좋겠습니다.</p>`,
		request: `<p>입력양식)</p><p>희망 단체명(기업): 동호회 0000팀</p><p>희망 일정: 2025년 3월 1일~6일 5박6일간</p><p>참여 인원: 총 10명</p><p>주행(운전) 경력: 초보자1인 외 9인</p><p>희망 나라(지역): 일본 아소 밀크로드</p><p>요청 사항: 내 바이크를 직접 가지고 가서 투어 하고 싶어요</p><p>대표자 연락처: 010-0000-0000</p><p>기타 문의:</p>`,
		review: "<p><br></p>",
		event: "<p><br></p>",
		qna: "<p><br></p>",
	};

	//let setPageLeaveWarning = usePageLeaveWarning({message: "저장되지 않은 변경사항이 있습니다. 정말로 나가시겠습니까?"});;


	const navigate = useNavigate();


	useMemo(async () => {	
		if (initData.token_info.permission_group === "guest") {
			
			navigate('/community');
			return;
		}

		let postId: string|null = localStorage.getItem("postId");

		if (postId === null) {
			// new id 제공받기
			const res3: any = await requestAPI('GET', `v1/community/id`, null);
	
			setContentsId(res3.data._id);
			postId = res3.data._id;
			localStorage.setItem("postId", res3.data._id);
		} else {
			const res_cp: any = await requestAPI ('FILE-CP', `community-temp-remove`, {
				contentsId: postId,
			});

			const res3: any = await requestAPI('GET', `v1/community/id`, null);
	
			setContentsId(res3.data._id);
			localStorage.setItem("postId", res3.data._id);
		}

		// 새로 고침을 시도할때 팝업 나오게

		const handleBeforeUnload = (event: any) => {
			event.preventDefault();
		};
	  
		window.addEventListener('beforeunload', handleBeforeUnload);
	  
		return () => {
	
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [])


	useEffect(() => {
		// 페이지에 변경사항이 있을 때 경고를 활성화		
		if (initData.token_info.permission_group === "guest") {
			
			navigate('/community');
			return;
		}

		(async () => {
			
			let res3: any = null;
			let productNo: any = null;
			let _data: any = null;
			if (id !== undefined) {
				res3 = await requestAPI('GET', `v1/community/${id}`, null);	
				_data = res3.data.info;
			}

			const res: any = await requestAPI('GET', `v1/reserve/me`, null);
			const reserveList = res.data.list;
			const res2: any = await requestAPI('GET', `v1/product/status/active`, null);
			const productList = res2.data.list;
			// const res3: any = await requestAPI('GET', `v1/community/id`, null);

			// setContentsId(res3.data._id);

			
			if (res3 !== null && _data.product_no !== null) {
				// 수정이고 상품이 등록된 경우
				productNo = _data.product_no;

				setReserveList(reserveList);
				setProductList(productList);

				if (_data.type==="review" && res.data.list.length > 0) {
					
					setReserveSelect(reserveList.find((item:any)=>item.product_no === productNo).product_no);
				}
	
				if (res2.data.list.length > 0) {
					
					setProductSelect (productList.find((item: any)=>item.no === productNo).no);
				}
			} else {
				setReserveList(reserveList);
				setProductList(productList);
				// 신규 글쓰기
				if (selectType==="review" && res.data.list.length > 0) {
					
					setReserveSelect(reserveList[0].product_no);
				}
	
				if (res2.data.list.length > 0) {
					
					setProductSelect(productList[0].no);
				}

				console.log('r3333', selectType)

				
			}
	
			if (res3 !== null) {
				handleTagClick(_data.type);
				setSelectType(_data.type);
				setOriginHtmlString(_data.contents);
				setEditorHtmlString(_data.contents);
				setTitle(_data.title);
				setData(_data);	
			}

		})();

	}, [])
 
	
	const setFileInfo = (file: any) => {
		const { name, size: byteSize, type } = file;
		const size = (byteSize / (1024 * 1024)).toFixed(2) + 'mb';
		
		setUploadedInfo({ name, size, type }); // name, size, type 정보를 uploadedInfo에 저장
	};

	const extractImageUrls = (htmlString: string) => {
		const regex = /src="([^"]+)"/g;
		const matches = htmlString.matchAll(regex);
		return Array.from(matches, match => match[1]);
	}

	const newPost = async () => {
		// 신규 글 작성
		let res_info: any = null;
		let selectItem: any = null;
		let galleryImgs: any = [];
		
		let files:any = extractImageUrls(editorHtmlString);
		let files2: any = [];
		
		files.forEach((item: any) => {
			const newItem = item.replace(`${process.env.REACT_APP_SERVER_FILE}/temp/`, "");			
			files2.push(newItem);
			galleryImgs.push(newItem);
		});

		const _contents = editorHtmlString.replaceAll(`${process.env.REACT_APP_SERVER_FILE}/temp`, `${process.env.REACT_APP_SERVER_FILE}/community/${contentsId}`);


		switch (selectType) {
			case "event":
				res_info = await requestAPI('POST', `v1/community`, {
					reviewType: "personal",
					id: contentsId,
					type: selectType,
					title,
					contents: _contents,
					selectNo: null,
					galleryImgs: galleryImgs
				});
				break;
			case "review":
				let params = {
					reviewType,
					id: contentsId,
					type: selectType,
					title,
					contents: _contents,
					selectNo: null,
					galleryImgs: galleryImgs,
					//product_cover: (imgUrl === null)? "" : imgUrl
				};

				if (reviewType === "reserved") {
					selectItem = reserveList.find((item: any) => item.product_no === reserveSelect);
					params.selectNo = selectItem.product_no;
				}

				res_info = await requestAPI('POST', `v1/community`, params);

				break;
			case "party":
			case "request":
			case "qna":
				selectItem = productList.find((item: any) => item.no === productSelect);				

				res_info = await requestAPI('POST', `v1/community`, {
					reviewType: reviewType2,
					id: contentsId,
					type: selectType,
					title,
					contents: _contents,
					selectNo: selectItem.no,
					galleryImgs: galleryImgs
				});
				break;
			
			// case "hotspot":
			// 	res_info = await requestAPI('POST', `v1/community`, {
			// 		id: contentsId,
			// 		type: selectType,
			// 		title,
			// 		contents: _contents,
			// 		selectNo: null,
			// 		galleryImgs: galleryImgs
			// 	});
			// 	break;
		}

		if (res_info.code === 1000) {
				
			const res_cp: any = await requestAPI ('FILE-CP', `community-cp`, {
				contentsId,
				files: files2
			});
		}

		navigate('/community');
	};

	const updatePost = async () => {
		// 글 수정
		let res_info: any = null;
		let selectItem: any = null;
		let galleryImgs: any = [];
		
		let files:any = extractImageUrls(editorHtmlString);
		let files2: any = [];
		let files3:any = extractImageUrls(originHtmlString);
		
		console.log("");console.log("");console.log("");

		files.forEach((item: any) => {
			
			console.log(item)

			if (item.search(`${process.env.REACT_APP_SERVER_FILE}/temp/`) > -1) {
				console.log(`${process.env.REACT_APP_SERVER_FILE}/temp/`)
				const newItem = item.replace(`${process.env.REACT_APP_SERVER_FILE}/temp/`, "");			
				files2.push(newItem);
				galleryImgs.push(newItem);
			} else {
				console.log(`${process.env.REACT_APP_SERVER_FILE}/community/${data._id}`)
				const newItem = item.replace(`${process.env.REACT_APP_SERVER_FILE}/community/${data._id}/`, "");			
				//files2.push(newItem);
				galleryImgs.push(newItem);
			}
		});

		const origin = data.galleryImgs;
		const changed = galleryImgs;

		const removedItems = origin.filter((item: string) => !changed.includes(item));

		console.log("removedItems", removedItems);
		console.log("newImages", galleryImgs);
		console.log("new Upload", files2);


		// console.log(files);
		// console.log(files3);
		// console.log(data.galleryImgs);
		// console.log(galleryImgs);

		const _contents = editorHtmlString.replaceAll(`${process.env.REACT_APP_SERVER_FILE}/temp`, `${process.env.REACT_APP_SERVER_FILE}/community/${data._id}`);


		switch (selectType) {
			case "event":
				res_info = await requestAPI('PUT', `v1/community`, {
					id: data._id,
					type: selectType,
					title,
					contents: _contents,
					selectNo: null,
					galleryImgs: galleryImgs,
					//product_cover: (imgUrl === null)? "" : imgUrl
				});
				break;
			case "review":
				// 기타 여행 후기는 선택 상품이 없음
				// 예약상품 후기는 선택 상품이 있음
				
				// 이 구분 필요

				selectItem = reserveList.find((item: any) => item.product_no === reserveSelect);

				console.log(selectItem);

				res_info = await requestAPI('PUT', `v1/community`, {
					id: data._id,
					type: selectType,
					title,
					contents: _contents,
					selectNo: selectItem.product_no,
					galleryImgs: galleryImgs,
					//product_cover: (imgUrl === null)? "" : imgUrl
				});


				break;
			case "party":
			case "request":
			case "qna":
				selectItem = productList.find((item: any) => item.no === productSelect);

				// console.log(title);
				// console.log(editorHtmlString);
				// console.log(selectType);
				// console.log(selectItem);

				res_info = await requestAPI('PUT', `v1/community`, {
					id: data._id,
					type: selectType,
					title,
					contents: _contents,
					selectNo: selectItem.no,
					galleryImgs: galleryImgs
				});
				break;
			// case "hotspot":

			// 	// console.log(title);
			// 	// console.log(editorHtmlString);
			// 	// console.log(selectType);


			// 	res_info = await requestAPI('PUT', `v1/community`, {
			// 		id: data._id,
			// 		type: selectType,
			// 		title,
			// 		contents: _contents,
			// 		selectNo: null,
			// 		galleryImgs: galleryImgs
			// 	});
			// 	break;
		}
		if (res_info.code === 1000) {
				
			const res_cp: any = await requestAPI ('FILE-CP', `community-modify`, {
				contentsId: data._id,
				files: files2,
				removeOriginFiles: removedItems
			});
		}

		navigate(`/community/${data._id}`);
	};


	  
	const handleSubmit = async () => {
		if (id === undefined) {
			newPost ();
		} else {
			updatePost ();
		}
	};

	const handleDelete = async () => {
		
		

		// setInfo(res_info.data.info);
	};

	const handleTagClick = async (type: string) => {

		

		// const postFormat = {
		// 	party: `입력양식)<br>가고 싶은 투어 상품 : 일본 아소 투어<br>가고 싶은 일자: 협의 혹은 원하는 날짜 라이딩(운전) 경력:  라이딩 10년 , 운전 20년<br>보유 기종(차종): 혼다 골드윙<br>주행 성향: 안전운전 및 평균 시속 100KM<br>기타 요청: 나이 불문, 성별 불문, 기종불문 성격 잘 맞고, 유쾌하게 투어 하실분이면 좋겠습니다.`,
		// 	request: `입력양식)<br>희망 단체명(기업): 동호회 0000팀<br>희망 일정: 2025년 3월 1일~6일 5박6일간<br>참여 인원: 총 10명<br> 주행(운전) 경력: 초보자1인 외 9인<br>희망 나라(지역): 일본 아소 밀크로드<br>요청 사항: 내 바이크를 직접 가지고 가서 투어 하고 싶어요<br>대표자 연락처: 010-0000-0000<br>기타 문의:<br> `,
		// 	review: "",
		// 	event: "",
		// 	qna: "",
		// };
		console.log("-----------")
		console.log(selectType);
		console.log(editorHtmlString);
		console.log(postFormat[selectType]);

		console.log("-----------")

		// if (JSON.stringify(editorHtmlString) !== JSON.stringify(postFormat[selectType])) {
		// 	alert('수정이 존재함');
		// }

		if (editorHtmlString !== postFormat[selectType])  {
			
			modal({
				title: "내용삭제", 
				contents: `확인을 누르면 작성된 컨텐츠가 삭제돼요`,
				buttons: [{
					label: '취소',
					color: 'ButtonSecondary',
					fn: () => {
						modal({title: "CLOSE", contents: "", buttons: []});
					}
				},
				{
					label: '확인',
					color: 'ButtonPrimary',
					fn: async () => {

						const res_cp: any = await requestAPI ('FILE-CP', `community-temp-remove`, {
							contentsId,
						});

						changeType(type);
						
						modal({title: "CLOSE", contents: "", buttons: []});						
					}
				}]
			});
		} else {
			changeType(type);
		}

		function changeType(type: string) {

			switch (type) {
				case "event":
					setEditorHtmlString("<p><br></p>");
					setReserveSw(false);
					setProductSw(false);
					break;
				case "review":
					setEditorHtmlString("<p><br></p>");
					setReserveSw(true);
					setProductSw(false);
					break;
	
				case "party":
					setEditorHtmlString(postFormat.party)
					setReserveSw(false);
					setProductSw(true);
					break;
				case "request":
					setEditorHtmlString(postFormat.request)
					setReserveSw(false);
					setProductSw(true);
					break;
				case "hotspot":
					setEditorHtmlString("<p><br></p>");
					setReserveSw(false);
					setProductSw(false);
					break;
				case "qna":
					setEditorHtmlString("<p><br></p>");
					setReserveSw(false);
					setProductSw(true);
					break;
			}

			setSelectType(type);
		}
	};

	const handleChangeReserve = (e: any) => {
		console.log(e.target.value);
		setReserveSelect(Number(e.target.value));
	};

	const handleChangeProduct = (e: any) => {
		setProductSelect(Number(e.target.value));
	};

	const handleBack = async () => {
		
		// console.log('XXXXXXXXXXXXXXXXXX');

		const res_cp: any = await requestAPI ('FILE-CP', `community-temp-remove`, {
			contentsId,
		});

		if (id === undefined) {
			navigate('/community');
		} else {
			navigate(`/community/${data._id}`);
		}

		
	}

	const requestTemp = async (imgData: any) => {
		
		//const file = input.files[0];
		const formData = new FormData();
		
		const userId = initData.userInfo._id;
		const file = imgData.name.split('.');
		const fileName = file[0]; 
		const fileExt = file[file.length-1]
		const id = Number(new Date());
		const newFileName = `${id}_${userId}.${fileExt}`;

		formData.append("file", imgData, newFileName);

		const res: any = await requestAPI ('FILE', `temp`, formData);

		const imgUrl = `/temp/${newFileName}`;

		setImgUrl(imgUrl)
	}

	const handleUpload = (e : any) => {

		let fileArr = e.target.files;
		let fileRead: any = new FileReader();

		setPostImg(Array.from(fileArr));
		setFileInfo(fileArr[0]);
    	
		fileRead.onload = function(){
			setPreviewImg(fileRead.result);	

			requestTemp(fileArr[0]);
		};
		
		fileRead.readAsDataURL(fileArr[0]);

		setImgData(fileArr[0]);
	};

	const handleImageDelete = () => {
		setPreviewImg ("");
		setImgUrl(null)
	}

	if (contentsId === "") return (<></>)

	return (
		<>

			<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
				<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
					<div className="flex items-center">
						<button
							className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
							onClick={() => handleBack()}
						>
							<ArrowSmallLeftIcon className="w-6 h-6" />
						</button>
						<span className="text-xl">
							뒤로
						</span>
					</div>
				</div>
			</div>

			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} sm:w-[768px] h-full h-screen bg-white !p-0`}>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem] mb-[10rem]">
						<div className="mt-5" />
						<div className="flex">
							<h2 className={`text-2xl md:text-4xl font-semibold flex items-top`}>
								{(id===undefined?"글쓰기":"글수정")}
							</h2>
						</div>
						<div className="mt-5" />

						<div className="text-neutral-6000 dark:text-neutral-300">
							<div className="space-y-3">
								{(initData.token_info.permission_group === "super") && (<button
									onClick={() => handleTagClick("event")}
								>
									<CommunityBadge
										className={`mr-3 ${selectType === "event" ? "ring-2 ring-blue-500" : ""}`}
										type={"event"}
										href={""}
										color={"blue"}
										onClick={() => handleTagClick("event")}
									/>
								</button>)}
								<button
									onClick={() => handleTagClick("review")}
								>
									<CommunityBadge
										className={`mr-3 ${selectType === "review" ? "ring-2 ring-blue-500" : ""}`}
										type={"review"}
										href={""}
										color={"blue"}
										onClick={() => handleTagClick("review")}
									/>
								</button>

								<button
									onClick={() => handleTagClick("party")}
								>
									<CommunityBadge
										className={`mr-3 ${selectType === "party" ? "ring-2 ring-blue-500" : ""}`}
										type={"party"}
										href={""}
										color={"green"}
										onClick={() => handleTagClick("party")}
									/>
								</button>

								<button
									onClick={() => handleTagClick("request")}
								>
									<CommunityBadge
										className={`mr-3 ${selectType === "request" ? "ring-2 ring-blue-500" : ""}`}
										type={"request"}
										href={""}
										color={"pink"}
										onClick={() => handleTagClick("request")}
									/>
								</button>

								{/* <button
									onClick={() => handleTagClick("hotspot")}
								>
									<CommunityBadge
										className={`mr-3 ${selectType === "hotspot" ? "ring-2 ring-blue-500" : ""}`}
										type={"hotspot"}
										href={""}
										color={"purple"}
										onClick={() => handleTagClick("hotspot")}
									/>
								</button> */}

								<button
									onClick={() => handleTagClick("qna")}
								>
									<CommunityBadge
										className={`mr-3 ${selectType === "qna" ? "ring-2 ring-blue-500" : ""}`}
										type={"qna"}
										href={""}
										color={"gray"}

									/>
								</button>
							</div>

							<div className="mt-5">
								{selectType === 'review' && (
									<div className="flex space-x-4 mb-4">
										<label className="flex items-center">
											<input
												type="radio"
												value="personal"
												checked={reviewType === 'personal'}
												onChange={(e) => setReviewType(e.target.value as 'personal' | 'reserved')}
												className="mr-2"
											/>
											기타 여행 후기
										</label>
										<label className={`flex items-center ${reserveList.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}>
										<input
											type="radio"
											value="reserved"
											checked={reviewType === 'reserved'}
											onChange={(e) => setReviewType(e.target.value as 'personal' | 'reserved')}
											className="mr-2"
											disabled={reserveList.length === 0}
										/>
											예약상품 후기
											{reserveList.length === 0 && <span className="ml-2 text-sm text-red-500">(예약상품이 없습니다)</span>}
										</label>
									</div>
								)}
								{reviewType === 'reserved' && reserveList.length > 0 && (
									<select
									onChange={(e) => handleChangeReserve(e)}
									className={`nc-Select block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900`}
									>
									{reserveList.map((item: any, idx: number) => (
										<option key={`reserveList_${idx}`} value={item.product_no}>
										{item.product_title}
										</option>
									))}
									</select>
								)}

								{(selectType === 'party' || selectType === 'request' || selectType === 'qna') && (
									<div className="flex space-x-4 mb-4">
										<label className="flex items-center">
										<input
											type="radio"
											value="personal2"
											checked={reviewType2 === 'personal2'}
											onChange={(e) => setReviewType2(e.target.value as 'personal2' | 'product')}
											className="mr-2"
										/>
										기타 여행 후기
										</label>
										<label className={`flex items-center ${productList.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}>
										<input
											type="radio"
											value="product"
											checked={reviewType2 === 'product'}
											onChange={(e) => setReviewType2(e.target.value as 'personal2' | 'product')}
											className="mr-2"
											disabled={productList.length === 0}
										/>
										상품
										{productList.length === 0 && <span className="ml-2 text-sm text-red-500">(상품이 없습니다)</span>}
										</label>
									</div>
								)}

								{(reviewType2 === "product") && (productSw === true) && (productList.length > 0)
									?
									<select
										onChange={(e) => handleChangeProduct(e)}
										className={`nc-Select block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900`}
									>
										{
											productList.length === 0 ?
												<></>
												:
												productList.map((item: any, idx: number) => {
													return (
														<option value={item.no}>
															{item.title}
														</option>
													)
												})
										}

									</select>
									:
									""
								}

							</div>

							<div className="mt-5">
								<Input
									value={title}
									onChange={e => setTitle(e.target.value)}
									placeholder="제목"
								/>
							</div>

							<div>
								<div className="mt-10" />
								<Editor
									rndId={rndId}
									contentsId={contentsId}
									description={""}
									editorHtmlString={editorHtmlString}
									setEditorHtmlString={setEditorHtmlString}	
									handleSubmit={handleSubmit}
								/>
							</div>

							<div className={`flex justify-center items-end w-full hidden`}>
								<div className="w-full">
									
									<div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
										<div className="text-center">
											{previewImg === ""
												?
												<>
													<PhotoIcon aria-hidden="true" className="mx-auto h-12 w-12 text-gray-300" />
													<div className="mt-4 text-sm leading-6 text-gray-600">
														<label
															htmlFor="test"
															className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
															
														>
															<span>Upload a file</span>
															<input 
																id="test" 
																name="attachment" 
																type="file" 
																className="sr-only"
																onChange={handleUpload}
																
															/>
														</label>
													</div>
													<p className="text-xs leading-5 text-gray-600">PNG, JPG, GIF up to 10MB</p>
												</>
												:
												<>
													<div className="flex items-center justify-center">
														<img src={previewImg} className="object-cover h-[300px]" />
													</div>		
													<div className="mt-4 text-sm leading-6 text-gray-600">
														<button onClick={() => handleImageDelete()}>
															<span>삭제</span>
														</button>
													</div>
												</>
											}
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
							
							<ButtonPrimary
								onClick={() => handleSubmit()}
							>
								저장
							</ButtonPrimary>
						</div>
					</div>

				</div>

			</div>
		</>
	);
};

export default CommunityPost;
